import { Ummeldung } from '../../../../generated/model/ummeldung.model';
import AktuellerProzessSchrittEnum = Ummeldung.AktuellerProzessSchrittEnum;
import {
  ROUTE_UMMELDUNG_BESTAETIGUNG,
  ROUTE_UMMELDUNG_CURRENT_CONTRACT_PARTNER,
  ROUTE_UMMELDUNG_DATE,
  ROUTE_UMMELDUNG_NEW_CONTRACT_PARTNER,
  ROUTE_UMMELDUNG_PRODUCT,
  ROUTE_UMMELDUNG_SUMMARY,
} from '../../../app.constants';
import { Router } from '@angular/router';

export function getAktuellerProzessSchrittFromUrl(router: Router): AktuellerProzessSchrittEnum | null {
  const path = router.url.split('?')[0];
  const lastSegment = path.substring(path.lastIndexOf('/') + 1);
  switch (lastSegment) {
    case ROUTE_UMMELDUNG_PRODUCT:
      return AktuellerProzessSchrittEnum.PRODUKT;
    case ROUTE_UMMELDUNG_DATE:
      return AktuellerProzessSchrittEnum.UMMELDEDATUM;
    case ROUTE_UMMELDUNG_CURRENT_CONTRACT_PARTNER:
      return AktuellerProzessSchrittEnum.BISHERIGER_VERTRAGSPARTNER;
    case ROUTE_UMMELDUNG_NEW_CONTRACT_PARTNER:
      return AktuellerProzessSchrittEnum.NEUER_VERTRAGSPARTNER;
    case ROUTE_UMMELDUNG_SUMMARY:
      return AktuellerProzessSchrittEnum.ZUSAMMENFASSUNG;
    case ROUTE_UMMELDUNG_BESTAETIGUNG:
      return AktuellerProzessSchrittEnum.BESTAETIGUNG;
    default:
      return null;
  }
}
